import React from 'react';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { range } from 'Helpers/Utils';

const styles = theme => ({
  root: {},
  rootGrayBackground: {
    backgroundColor: theme.palette.facet.lightGray,
  },
});

const ListSkeletons = ({
  classes,
  className,
  component,
  componentProps,
  count,
  showGrayBackground,
}) => {
  const SkeletonComponent = component;

  return range(count).map((i) => {
    return (
      <SkeletonComponent
        key={i}
        className={classNames(classes.root, className, {
          [classes.rootGrayBackground]: i % 2 === 1 && showGrayBackground,
        })}
        {...componentProps}
      />
    );
  });
};

ListSkeletons.defaultProps = {
  componentProps: {},
  count: 3,
};

export default withStyles(styles)(ListSkeletons);
